<template>
  <div class="container">
    <LanguageRegister />
    <div class="logo">
      <img :src="this.publicData.serverUrl + 'images/logo @2x.png'" alt="" />
      <router-link to="/home">
        <i class="el-icon-error"></i>
      </router-link>
    </div>
    <div class="register">
      <div class="register-type">
        <div class="register-type-item" @click="goLogin">
          {{ $t('lang.external.login.登录') }}
        </div>
        <div class="register-type-item active">
          {{ $t('lang.external.register.注册') }}
        </div>
      </div>
      <el-form
        :model="registerForm"
        :rules="registerRules"
        ref="registerFormRef"
        class="register-form"
      >
        <el-form-item prop="userName">
          <el-input
            v-model="registerForm.userName"
            :placeholder="$t('lang.external.register.请输入手机号/邮箱')"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/zh@2x.png'"
                alt=""
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="userPassword">
          <el-input
            type="password"
            v-model="registerForm.userPassword"
            :placeholder="$t('lang.external.register.请输入6-11位密码')"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/mm@2x.png'"
                alt=""
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="checkPassword">
          <el-input
            type="password"
            v-model="registerForm.checkPassword"
            :placeholder="$t('lang.external.register.请再次输入密码')"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/mm@2x.png'"
                alt=""
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="registerForm.code"
            :placeholder="$t('lang.external.register.请输入验证码')"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/yzm@2x.png'"
                alt=""
              />
            </template>
            <template slot="append">
              <span v-if="countdown === 0" class="captcha" @click="getCaptcha">
                {{ $t('lang.external.register.获取验证码') }}
              </span>
              <span v-else class="captcha btn-cancel">
                <i class="el-icon-loading"></i> {{ countdown }}
              </span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="register-btns">
        <span class="btn" @click="submit">
          {{ $t('lang.external.register.立即注册') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { sendCode, register } from '@/api/user/user'
import { checkUserName } from '@/utils/validate'
import LanguageRegister from '@/components/experimentation/languageLayout/language-login'
export default {
  name: 'register',
  components: { LanguageRegister },
  props: [],
  data() {
    var that = this
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(that.$t('lang.external.register.请输入密码')))
      } else {
        if (this.registerForm.checkPassword !== '') {
          this.$refs.registerFormRef.validateField('checkPassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(that.$t('lang.external.register.请再次输入密码')))
      } else if (value !== this.registerForm.userPassword) {
        callback(
          new Error(that.$t('lang.external.register.两次输入密码不一致!'))
        )
      } else {
        callback()
      }
    }
    return {
      registerForm: {
        userName: '',
        userPassword: '',
        checkPassword: '',
        code: '',
      },
      registerRules: {
        userName: [{ validator: checkUserName, trigger: 'blur' }],
        userPassword: [
          { validator: validatePass, trigger: 'blur' },
          {
            min: 6,
            max: 11,
            message: this.$t('lang.external.register.长度在6到11个字符'),
            trigger: 'blur',
          },
        ],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }],
        code: [
          {
            required: true,
            message: this.$t('lang.external.register.请输入验证码'),
            trigger: 'blur',
          },
        ],
      },
      countdown: 0,
      timer: null,
    }
  },
  watch: {
    countdown(n) {
      if (n === 0) clearInterval(this.timer)
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    submit() {
      this.$refs.registerFormRef.validate(async (valid) => {
        if (!valid) return
        await register(this.registerForm).then((res) => {
          this.$notify({
            type: 'success',
            message: this.$t('lang.external.register.注册成功！'),
            duration: 1500,
            title: 'SUCCESS',
          })
          this.goLogin()
        })
      })
    },
    getCaptcha() {
      this.$refs.registerFormRef.validateField('userName', (valid) => {
        if (valid) return console.log(valid)
        this.setCountdown()
        sendCode({
          userName: this.registerForm.userName,
        })
          .then((res) => {
            // this.countdown = 0
            // clearInterval(this.timer)
            this.$notify({
              type: 'success',
              message: this.$t('lang.external.register.发送成功！'),
              duration: 1500,
              title: 'SUCCESS',
            })
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    setCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) this.countdown--
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: var(--logo-bg);
  background-size: 100% 100%;
  color: #888888;
  font-size: 16px;
  .logo {
    padding: 3.7962vh 3.125vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      height: 5.3vh;
    }
    i {
      color: #f4f8fa;
      font-size: 2.1875vw;
      &:hover {
        color: #8c413f;
        cursor: pointer;
      }
    }
  }
  .register {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30%;
    padding: 40px;
    box-sizing: content-box;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    &-type {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 25px;
      &-item {
        margin: 0 60px;
        padding-bottom: 10px;
        border-bottom: 3px solid rgba(255, 255, 255, 0.95);
        cursor: pointer;
      }
      .active {
        font-size: 20px;
        font-weight: bold;
        color: #0c5893;
        border-bottom: 3px solid #0c5893;
      }
    }
    &-form {
      .el-input {
        font-size: 16px;
      }
      ::v-deep .el-input__inner {
        border: none;
        color: #888888;
        background-color: #e4eaf0;
        height: 50px;
        padding-left: 40px;
        line-height: 50px;
      }
      .prefix-img {
        height: 35%;
      }
      .captcha {
        color: #fff;
        background-color: #a63528;
        padding: 15px 20px;
        border-radius: 0px 5px 5px 0px;
        cursor: pointer;
      }
    }
    &-btns {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 6.25vh;
      .btn {
        background-color: #0c5893;
        line-height: 3;
        border-radius: 25px;
      }
    }
  }
}
</style>

<style lang="scss">
.register-form {
  .el-input__prefix {
    left: 10px;
    line-height: 50px;
  }
  .el-input-group__append {
    border: 0;
    padding: 0;
  }
}
</style>